'use client';

import React, { useEffect, useState } from 'react';

const BAR_HEIGHTS = [18, 34, 26, 46, 30, 52, 22, 44, 30, 50, 24, 40, 28, 36];

/**
 * Brief branded loading overlay (wordmark + animated waveform) shown on the
 * first load of a browser session, then fades out. Skips on subsequent
 * navigations/reloads in the same session and respects reduced-motion.
 */
export default function PreLoader() {
  const [mounted, setMounted] = useState(true);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem('dg_preloaded')) {
      setMounted(false);
      return;
    }
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const minDelay = reduce ? 250 : 1150;
    const start = performance.now();

    const finish = () => {
      const wait = Math.max(0, minDelay - (performance.now() - start));
      window.setTimeout(() => {
        sessionStorage.setItem('dg_preloaded', '1');
        setHidden(true);
        window.setTimeout(() => setMounted(false), 600);
      }, wait);
    };

    if (document.readyState === 'complete') finish();
    else window.addEventListener('load', finish, { once: true });
    return () => window.removeEventListener('load', finish);
  }, []);

  if (!mounted) return null;

  return (
    <div
      aria-hidden="true"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 100000,
        background: '#000000',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '26px',
        opacity: hidden ? 0 : 1,
        transition: 'opacity 0.55s ease',
        pointerEvents: hidden ? 'none' : 'auto',
      }}
    >
      <div
        style={{
          fontFamily: 'Manrope, sans-serif',
          fontWeight: 900,
          fontSize: 'clamp(1.5rem, 5vw, 2.6rem)',
          letterSpacing: '0.14em',
          textTransform: 'uppercase',
          color: '#ffffff',
          textShadow: '0 0 16px rgba(255,26,26,0.9), 0 0 36px rgba(255,26,26,0.5)',
        }}
      >
        Diggity Glover
      </div>
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: '4px', height: '52px' }}>
        {BAR_HEIGHTS.map((h, i) => (
          <span key={i} className="waveform-bar" style={{ height: `${h}px` }} />
        ))}
      </div>
    </div>
  );
}
